import customFetch from './customFetch';

export const getWebCards = () => customFetch('/web-cards?limit=999');

export const getWebCard = (id) => customFetch(`/web-cards/${id}`);

export const deleteWebCards = (id) => customFetch(`/web-cards/${id}`, { method: 'DELETE' });

export const putWebCards = (id, data) => (
  customFetch('/web-cards', {
    method: 'POST',
    body: JSON.stringify({ ...data, id }),
  })
);

export const postWebCards = (data) => (
  customFetch('/web-cards', {
    method: 'POST',
    body: JSON.stringify(data),
  })
);

export const bulkPutWebCards = (updatedCards) => (
  customFetch('/web-cards/bulk', {
    method: 'POST',
    body: JSON.stringify(updatedCards),
  })
);
